import { upsertLiftStation } from '@Actions/stations.action';
import UpsertLiftStationForm from '@Components/UpsertLiftStationForm';
import { Button, PageWrapper } from '@innovyze/stylovyze';
import LoadingButton from '@Pages/UploadSensorData/ActionButton';
import { getValue } from '@Selectors';
import { useGlobalization } from '@Translations';
import {
	DEFAULT_FACILITY_TYPE,
	LiftStationFormFields,
	STATUS_ENUM,
} from '@Types';
import { MAIN_ROUTES } from '@Types/routes';
import { FormikProps } from 'formik';
import React, { useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

export default function CreateLiftStation(): React.ReactElement {
	const { t } = useGlobalization();
	const dispatch = useDispatch();
	const history = useHistory();
	const formRef = useRef<FormikProps<LiftStationFormFields>>();
	const {
		upsertLiftStation: { status },
	} = useSelector(getValue).stations;
	const handleSubmit = (values: LiftStationFormFields) => {
		dispatch(upsertLiftStation(values));
	};
	const [isValid, setIsValid] = useState(false);

	return (
		<PageWrapper
			title={t('New Facility')}
			secondary={
				<>
					<Button
						dataCy="cancelLiftStation"
						variant="contained"
						color="secondary"
						onClick={() => {
							history.push(MAIN_ROUTES.Stations);
						}}>
						{t('Cancel')}
					</Button>
					<LoadingButton
						data-cy="saveLiftStation"
						style={{ marginLeft: 8 }}
						variant="contained"
						color="primary"
						onClick={() => {
							if (formRef?.current) {
								formRef?.current?.submitForm();
							}
						}}
						loading={status === STATUS_ENUM.PENDING}
						disabled={status === STATUS_ENUM.PENDING || !isValid}>
						{t('Save')}
					</LoadingButton>
				</>
			}
			applyPadding
			headerUnderline>
			{handleSubmit && (
				<UpsertLiftStationForm
					onSubmit={handleSubmit}
					ref={formRef}
					initialValues={{
						name: '',
						location: '',
						type: DEFAULT_FACILITY_TYPE,
						sensors: [],
						sensorGroups: [],
						images: [],
					}}
					isValid={isValid}
					setIsValid={setIsValid}
				/>
			)}
		</PageWrapper>
	);
}
